import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FormSubsection from '../../../../widgets/FormSubsection/FormSubsection';
import { Hidden } from '@material-ui/core';
import CustomTextInput from '../../../../widgets/CustomTextInput/CustomTextInput';
import { PRODUCT_LINE_ITEM_FIELDS } from '../line-item-page-util';
import { containsMutableField } from '../line-item-page-util';
import { isFieldVisible } from '../../../../../utils/bill-method-util';
import { Snackbar } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { cloneDeep } from 'lodash';
import CustomValueModal from '../../../../widgets/CustomValueModal/CustomValueModal';
import { DialogueTypes } from '../../../../widgets/CustomValueModal/definitions';
import { showInventoryMaintenanceAsPercent } from '../../../../../utils/renewals-util';
import { connect } from 'react-redux';
class ProductInventoryPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      disabled: true,
      appConfigs: this.props.appStore.appConfigs
    };

    this.toggleDisabled = this.toggleDisabled.bind(this);
    this.handleChangeLineItem = this.handleChangeLineItem.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    /**
     * Dead Code
     */
    /*this.toggleAdjustmentPopup = this.toggleAdjustmentPopup.bind(this);
    this.handleAccept = this.handleAccept.bind(this);*/
  }

  // dead code region //
  // we are leaving these dead codes here, in case business changes their mind //
  // in order to activate these, we will need to have the following two for the state
  // showAdjustmentPopup: false,
  // adjustmentPopupField: null

  showAdjustmentPopup(fieldName) {
    this.setState({
      showAdjustmentPopup: true,
      adjustmentPopupField: fieldName
    });
  }

  toggleAdjustmentPopup() {
    this.setState({
      showAdjustmentPopup: !this.state.showAdjustmentPopup
    });
  }

  handleAccept(value, adjustmentReason) {
    const lineItem = cloneDeep(this.props.lineItem);
    lineItem.adjustedQuantity[this.state.adjustmentPopupField] = value;
    lineItem.quantityAdjustmentReason = adjustmentReason;
    this.props.handleChangeLineItem(lineItem);
    this.setState({
      showAdjustmentPopup: false
    });
  }
  // dead code region ended //

  toggleDisabled() {
    this.setState({
      disabled: !this.state.disabled || this.props.disabled
    });
  }

  handleChangeLineItem(fieldName, value, submitUpdates = false) {
    const lineItem = PRODUCT_LINE_ITEM_FIELDS[fieldName].getUpdatedLineItem(
      this.props.lineItem,
      value
    );
    this.props.handleChangeLineItem(lineItem, submitUpdates);
  }

  handleBlur(fieldName, value) {
    this.handleChangeLineItem(fieldName, value, true);
  }

  render() {
    const rentalQuantityName = PRODUCT_LINE_ITEM_FIELDS.rentalQuantity.name;
    const deliveryQuantityName = PRODUCT_LINE_ITEM_FIELDS.deliveryQuantity.name;
    const circulatingInventoryName =
      PRODUCT_LINE_ITEM_FIELDS.circulatingInventory.name;
    const minUsePercentageName = PRODUCT_LINE_ITEM_FIELDS.minUsePercentage.name;
    const inventoryMaintenanceName =
      PRODUCT_LINE_ITEM_FIELDS.inventoryMaintenance.name;
    const INVENTORY_MAINTENANCE_TYPE_NAME =
      PRODUCT_LINE_ITEM_FIELDS.inventoryMaintenance.visibilityField;
    const weeklyUsageName = PRODUCT_LINE_ITEM_FIELDS.weeklyUsage.name;
    const isCircInventoryVisible = true;
    const isBold = false;
    const mutableFields = {
      [rentalQuantityName]: this.props.isFieldEditable(
        rentalQuantityName,
        this.props.lineItem
      ),
      [deliveryQuantityName]: this.props.isFieldEditable(
        deliveryQuantityName,
        this.props.lineItem
      ),
      [circulatingInventoryName]: this.props.isFieldEditable(
        circulatingInventoryName,
        this.props.lineItem
      ),
      [minUsePercentageName]: this.props.isFieldEditable(
        minUsePercentageName,
        this.props.lineItem
      ),
      [inventoryMaintenanceName]: this.props.isFieldEditable(
        inventoryMaintenanceName,
        this.props.lineItem
      ), 
      [weeklyUsageName]: this.props.isFieldEditable(
        weeklyUsageName,
        this.props.lineItem
      )
    };

    return (
      <FormSubsection
        title="Product Inventory & Usage"
        disabled={this.state.disabled}
        toggleDisabled={this.toggleDisabled}
        showEdit={containsMutableField(mutableFields) && !this.props.disabled && !(this.state.appConfigs['DISABLE_RENEWAL_EDITS']?.value === 'true')}
      >
        <div
          className="
              row
              field-container"
        >
          <Hidden
            xsUp={
              !isFieldVisible(
                rentalQuantityName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[rentalQuantityName]
              )
            }
          >
            <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
            >
              <CustomTextInput
                labelText={PRODUCT_LINE_ITEM_FIELDS[rentalQuantityName].label}
                disabled={
                  this.state.disabled || !mutableFields[rentalQuantityName]
                }
                initialValue={
                  this.props.lineItem.baseQuantity[rentalQuantityName]
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[rentalQuantityName]
                }
                isValidChange={(value) => value !== '' && value >= 1}
                onBlur={(value) => this.handleBlur(rentalQuantityName, value)}
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  rentalQuantityName
                )}
              />
            </div>
          </Hidden>
          <Hidden
            xsUp={
              !isFieldVisible(
                deliveryQuantityName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[deliveryQuantityName]
              )
            }
          >
            <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
            >
              <CustomTextInput
                labelText={PRODUCT_LINE_ITEM_FIELDS[deliveryQuantityName].label}
                disabled={
                  this.state.disabled || !mutableFields[deliveryQuantityName]
                }
                initialValue={
                  this.props.lineItem.baseQuantity[deliveryQuantityName]
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[deliveryQuantityName]
                }
                isValidChange={(value) => value !== '' && value >= 1}
                onBlur={(value) => this.handleBlur(deliveryQuantityName, value)}
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  deliveryQuantityName
                )}
              />
            </div>
          </Hidden>
          <Hidden
            xsUp={
              !isFieldVisible(
                circulatingInventoryName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[circulatingInventoryName]
              )
            }
          >
            {!(this.props.lineItem.billMethod === 'WeeklyUsage') && <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
            >
               <CustomTextInput
                labelText={
                  PRODUCT_LINE_ITEM_FIELDS[circulatingInventoryName].label
                }
                disabled={
                  this.state.disabled ||
                  !mutableFields[circulatingInventoryName] || this.props.lineItem.billMethod === "WeeklyUsage"
                }
                initialValue={
                  this.props.lineItem.baseQuantity[circulatingInventoryName]
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[circulatingInventoryName]
                }
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  circulatingInventoryName
                )}
                isValidChange={(value) => value !== '' && value >= 1}
                onBlur={(value) =>
                  this.handleBlur(circulatingInventoryName, value)
                }
              />
            </div>}
          </Hidden>
          <Hidden
            xsUp={
              !isFieldVisible(
                weeklyUsageName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[weeklyUsageName]
              )
            }
          >
            <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
              style={{ fontWeight: isBold ? 'bold' : 'normal' }}
            >
              <CustomTextInput
                labelText={PRODUCT_LINE_ITEM_FIELDS[weeklyUsageName].label}
                disabled={
                  this.state.disabled || !mutableFields[weeklyUsageName]
                }
                initialValue={
                  this.props.lineItem.baseQuantity[weeklyUsageName]
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[weeklyUsageName]
                }
                isValidChange={(value) => value !== '' && value >= 1}
                onBlur={(value) => this.handleBlur(weeklyUsageName, value)}
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  weeklyUsageName
                )}
              />
            </div>
          </Hidden>
          <Hidden
            xsUp={
              !isFieldVisible(
                minUsePercentageName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[minUsePercentageName]
              )
            }
          >
            <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
            >
              <CustomTextInput
                labelText={PRODUCT_LINE_ITEM_FIELDS[minUsePercentageName].label}
                disabled={
                  this.state.disabled || !mutableFields[minUsePercentageName]
                }
                initialValue={
                  this.props.lineItem.baseQuantity[minUsePercentageName] != null
                    ? this.props.lineItem.baseQuantity[minUsePercentageName] *
                      100
                    : null
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[minUsePercentageName] !=
                  null
                    ? this.props.lineItem.adjustedQuantity[
                        minUsePercentageName
                      ] * 100
                    : null
                }
                endAdornment="%"
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  minUsePercentageName
                )}
                isValidChange={(value) => value !== '' && value > 0}
                onBlur={(value) =>
                  this.handleBlur(
                    minUsePercentageName,
                    value != null ? value / 100 : null
                  )
                }
              />
            </div>
          </Hidden>
          <Hidden
            xsUp={
              !isFieldVisible(
                inventoryMaintenanceName,
                this.props.lineItem.billMethod,
                this.props.lineItem.adjustedQuantity[
                  INVENTORY_MAINTENANCE_TYPE_NAME
                ],
                this.props.lineItem.typeOfMerchandise
              )
            }
          >
            <div
              className="
                      col-xs-12
                      col-sm-2
                      padding-wrapper"
            >
              <CustomTextInput
                labelText={
                  PRODUCT_LINE_ITEM_FIELDS[inventoryMaintenanceName].label
                }
                disabled={
                  this.state.disabled ||
                  !mutableFields[inventoryMaintenanceName]
                }
                initialValue={
                  this.props.lineItem.baseQuantity.inventoryMaintenance
                }
                selectedValue={
                  this.props.lineItem.adjustedQuantity[inventoryMaintenanceName]
                }
                endAdornment={
                  showInventoryMaintenanceAsPercent(
                    this.props.lineItem.adjustedQuantity[
                      INVENTORY_MAINTENANCE_TYPE_NAME
                    ]
                  )
                    ? '%'
                    : ''
                }
                approvalRequired={this.props.fieldChangeRequiresApproval(
                  inventoryMaintenanceName
                )}
                isValidChange={(value) => value !== '' && value >= 1}
                onBlur={(value) =>
                  this.handleBlur(inventoryMaintenanceName, value)
                }
              />
            </div>
          </Hidden>

        </div>
        {this.state.showAdjustmentPopup ? (
          <CustomValueModal
            initialValue={
              this.props.lineItem.baseQuantity[this.state.adjustmentPopupField]
            }
            adjustedValue={
              this.props.lineItem.adjustedQuantity[
                this.state.adjustmentPopupField
              ]
            }
            labelText={
              PRODUCT_LINE_ITEM_FIELDS[this.state.adjustmentPopupField].label
            }
            lineItemField={this.state.adjustmentPopupField}
            handleAccept={this.handleAccept}
            handleClose={this.toggleAdjustmentPopup}
            type={DialogueTypes.Quantity}
            adjustmentReason={this.props.lineItem.quantityAdjustmentReason}
            isModalOpen={this.state.showAdjustmentPopup}
          />
        ) : null}

        <Snackbar
          open={!!this.state.message}
          onClose={() => {
            this.setState({ message: null });
          }}
          autoHideDuration={5000}
          message={this.state.message}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        />
      </FormSubsection>
    );
  }
}

ProductInventoryPanel.propTypes = {
  disabled: PropTypes.bool,
  lineItem: PropTypes.object,
  handleChangeLineItem: PropTypes.func,
  isFieldEditable: PropTypes.func,
  fieldChangeRequiresApproval: PropTypes.func
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default connect(mapStateToProps)(ProductInventoryPanel);
